<script type="text/javascript">
var lastTouchEnd = 0;
document.documentElement.addEventListener('touchend', function (event) {
  var now = Date.now();
  if (now - lastTouchEnd <= 300) {
    event.preventDefault();
  }
  lastTouchEnd = now;
}, false);
window._MICHAT = window._MICHAT || function () {
  (_MICHAT.a = _MICHAT.a || []).push(arguments)
};
_MICHAT("accountid", 127698);
_MICHAT("domain", "maichat.mdejk.com");
(function (m, d, q, j, s) {
  j = d.createElement(q), s = d.getElementsByTagName(q)[0];
  j.async = true;
  j.charset = "UTF-8";
  j.src = ("https:" == document.location.protocol ? "https://" : "http://") + "maichat.mdejk.com/Web/JS/mivisit.js?_=t";
  s.parentNode.insertBefore(j, s);
})(window, document, "script");

// 禁用Y轴滚动条
const that = this;
// window.onresize = () => {
//   return (() => {
//     window.screenWidth = document.documentElement.clientWidth;
//     window.screenWidth >= 1200 ? document.body.style.overflowX='hidden' : document.body.style.overflowX='';
//   })();
// };
document.body.style.overflowX = 'hidden'
</script>
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style>
</style>
